const data = [
  {
    "id": 1,
    "title": "Quem somos", 
    "descricao": "A Cromo Construtora é uma empresa do Grupo Honaiser, formado também pelas empresas: Lavronorte e Unibalsas.\nAtuamos desde 1989 como construtora e nos tornamos incorporadora em [ano], para ajudar ainda mais Balsas (e o Sul do Maranhão) a caminharem rumo a um futuro de oportunidades. Um de nossos primeiros empreendimentos foi o Residencial Veneza, pelo Minha Casa Minha Vida, entregue em 2015. Um marco na história do município. Agora, uma nova etapa está em andamento, na área de Balsas que mais cresce. Com os lançamentos dos Residenciais Florença Primeira e Segunda Etapa, começa um novo bairro na cidade, cheio de sonhos e oportunidades. E, em breve, mais novidades vão surgir, com a qualidade e a confiança que são a marca da Cromo Construtora."
  },
];

export default data;
